var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('Intro',{staticClass:"px-xs-32 intro-over-banner"}),_c('Range',{attrs:{"bg":_vm.wWidth<768?require('@/assets/phone/abMapFont.png'):require('@/assets/d_map.gif')}}),_c('Honor',{staticClass:"px-xs-32"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }